var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscordLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2625 1.81875C17.2625 1.81875 15.1813 0.1875 12.7188 0L12.5 0.443749C14.725 0.987499 15.7437 1.76875 16.8125 2.725C14.975 1.7875 13.1562 0.90625 9.99375 0.90625C6.83125 0.90625 5.0125 1.7875 3.175 2.725C4.24375 1.76875 5.45625 0.899999 7.4875 0.443749L7.26875 0C4.6875 0.24375 2.725 1.81875 2.725 1.81875C2.725 1.81875 0.4 5.19375 0 11.8188C2.34375 14.525 5.90625 14.5437 5.90625 14.5437L6.65 13.55C5.3875 13.1125 3.95625 12.325 2.725 10.9062C4.19375 12.0188 6.41875 13.1812 10 13.1812C13.5813 13.1812 15.8 12.025 17.275 10.9062C16.0438 12.325 14.6125 13.1125 13.35 13.55L14.0938 14.5437C14.0938 14.5437 17.6562 14.525 20 11.8188C19.5875 5.19375 17.2625 1.81875 17.2625 1.81875ZM7.03125 10C6.15 10 5.4375 9.1875 5.4375 8.18125C5.4375 7.175 6.15 6.3625 7.03125 6.3625C7.9125 6.3625 8.625 7.175 8.625 8.18125C8.625 9.1875 7.9125 10 7.03125 10ZM12.9437 10C12.0625 10 11.35 9.1875 11.35 8.18125C11.35 7.175 12.0625 6.3625 12.9437 6.3625C13.825 6.3625 14.5375 7.175 14.5375 8.18125C14.5375 9.1875 13.8187 10 12.9437 10Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscordLogo);
export default __webpack_public_path__ + "static/media/discord-logo.4847c35a2ca219e3ce46ab2bf1062a82.svg";
export { ForwardRef as ReactComponent };